import React, { FC, useEffect, useState } from 'react';
import { loadIcon } from '../../../scripts';

interface CoinIconProps {
    symbol: string;
    className?: string;
    size?: 'small' | 'default';
}

const _CoinIcon: FC<CoinIconProps> = (props) => {
    const [iconPath, setIconPath] = useState<string | null>(null);

    useEffect(() => {
        let isCurrent = true;

        const fetchIcon = async () => {
            const path = await loadIcon(props.symbol.toLowerCase());

            if (isCurrent) {
                setIconPath(path);
            }
        };

        fetchIcon();

        return () => {
            isCurrent = false;
        };
    }, [props.symbol]);

    return (
        <img
            className={`${props.size === 'small' ? 'w-6 h-6' : 'w-8 h-8'} ${props.className}`}
            src={iconPath || ''}
            alt={props.symbol}
        />
    );
};

export default _CoinIcon;
